// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTADocumentContent } from './dta-document-content';
import {
    DTADocumentContentFromJSON,
    DTADocumentContentFromJSONTyped,
    DTADocumentContentToJSON,
    DTADocumentContentToJSONTyped,
} from './dta-document-content';
import type { DTADetailsAuditTrailInner } from './dta-details-audit-trail-inner';
import {
    DTADetailsAuditTrailInnerFromJSON,
    DTADetailsAuditTrailInnerFromJSONTyped,
    DTADetailsAuditTrailInnerToJSON,
    DTADetailsAuditTrailInnerToJSONTyped,
} from './dta-details-audit-trail-inner';
import type { DTAStatus } from './dta-status';
import {
    DTAStatusFromJSON,
    DTAStatusFromJSONTyped,
    DTAStatusToJSON,
    DTAStatusToJSONTyped,
} from './dta-status';
import type { DTADetailsStatusHistoryInner } from './dta-details-status-history-inner';
import {
    DTADetailsStatusHistoryInnerFromJSON,
    DTADetailsStatusHistoryInnerFromJSONTyped,
    DTADetailsStatusHistoryInnerToJSON,
    DTADetailsStatusHistoryInnerToJSONTyped,
} from './dta-details-status-history-inner';
import type { WorkflowApproval } from './workflow-approval';
import {
    WorkflowApprovalFromJSON,
    WorkflowApprovalFromJSONTyped,
    WorkflowApprovalToJSON,
    WorkflowApprovalToJSONTyped,
} from './workflow-approval';
import type { SourceType } from './source-type';
import {
    SourceTypeFromJSON,
    SourceTypeFromJSONTyped,
    SourceTypeToJSON,
    SourceTypeToJSONTyped,
} from './source-type';
import type { WorkflowStage } from './workflow-stage';
import {
    WorkflowStageFromJSON,
    WorkflowStageFromJSONTyped,
    WorkflowStageToJSON,
    WorkflowStageToJSONTyped,
} from './workflow-stage';
import type { DTADetailsSourceDocument } from './dta-details-source-document';
import {
    DTADetailsSourceDocumentFromJSON,
    DTADetailsSourceDocumentFromJSONTyped,
    DTADetailsSourceDocumentToJSON,
    DTADetailsSourceDocumentToJSONTyped,
} from './dta-details-source-document';

/**
 * 
 * @export
 * @interface DTADetails
 */
export interface DTADetails {
    /**
     * Inline approvals for the current version
     * @type {Array<WorkflowApproval>}
     * @memberof DTADetails
     */
    approvals?: Array<WorkflowApproval>;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    approved_at?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    approved_by?: string;
    /**
     * 
     * @type {Array<DTADetailsAuditTrailInner>}
     * @memberof DTADetails
     */
    audit_trail?: Array<DTADetailsAuditTrailInner>;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    data_stream_id?: string;
    /**
     * 
     * @type {DTADocumentContent}
     * @memberof DTADetails
     */
    document_content: DTADocumentContent;
    /**
     * 
     * @type {Array<string>}
     * @memberof DTADetails
     */
    domains: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    dta_id: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    extraction_error?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    extraction_job_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    extraction_status?: DTADetailsExtractionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    ingestion_spec_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    last_modified_at: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    last_modified_by: string;
    /**
     * The latest version number from DTA metadata
     * @type {string}
     * @memberof DTADetails
     */
    latest_version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DTADetails
     */
    locked: boolean;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    rejection_reason?: string;
    /**
     * 
     * @type {DTADetailsSourceDocument}
     * @memberof DTADetails
     */
    source_document?: DTADetailsSourceDocument;
    /**
     * 
     * @type {SourceType}
     * @memberof DTADetails
     */
    source_type?: SourceType;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    spec_id?: string;
    /**
     * 
     * @type {DTAStatus}
     * @memberof DTADetails
     */
    status: DTAStatus;
    /**
     * 
     * @type {Array<DTADetailsStatusHistoryInner>}
     * @memberof DTADetails
     */
    status_history?: Array<DTADetailsStatusHistoryInner>;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    study_id: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    vendor_id: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    vendor_name: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetails
     */
    version: string;
    /**
     * 
     * @type {WorkflowStage}
     * @memberof DTADetails
     */
    workflow_stage: WorkflowStage;
}


/**
 * @export
 */
export const DTADetailsExtractionStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Complete: 'COMPLETE',
    Failed: 'FAILED'
} as const;
export type DTADetailsExtractionStatusEnum = typeof DTADetailsExtractionStatusEnum[keyof typeof DTADetailsExtractionStatusEnum];


/**
 * Check if a given object implements the DTADetails interface.
 */
export function instanceOfDTADetails(value: object): value is DTADetails {
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('document_content' in value) || value['document_content'] === undefined) return false;
    if (!('domains' in value) || value['domains'] === undefined) return false;
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('last_modified_at' in value) || value['last_modified_at'] === undefined) return false;
    if (!('last_modified_by' in value) || value['last_modified_by'] === undefined) return false;
    if (!('locked' in value) || value['locked'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('study_id' in value) || value['study_id'] === undefined) return false;
    if (!('vendor_id' in value) || value['vendor_id'] === undefined) return false;
    if (!('vendor_name' in value) || value['vendor_name'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('workflow_stage' in value) || value['workflow_stage'] === undefined) return false;
    return true;
}

export function DTADetailsFromJSON(json: any): DTADetails {
    return DTADetailsFromJSONTyped(json, false);
}

export function DTADetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADetails {
    if (json == null) {
        return json;
    }
    return {
        
        'approvals': json['approvals'] == null ? undefined : ((json['approvals'] as Array<any>).map(WorkflowApprovalFromJSON)),
        'approved_at': json['approved_at'] == null ? undefined : json['approved_at'],
        'approved_by': json['approved_by'] == null ? undefined : json['approved_by'],
        'audit_trail': json['audit_trail'] == null ? undefined : ((json['audit_trail'] as Array<any>).map(DTADetailsAuditTrailInnerFromJSON)),
        'created_at': json['created_at'],
        'created_by': json['created_by'],
        'data_stream_id': json['data_stream_id'] == null ? undefined : json['data_stream_id'],
        'document_content': DTADocumentContentFromJSON(json['document_content']),
        'domains': json['domains'],
        'dta_id': json['dta_id'],
        'extraction_error': json['extraction_error'] == null ? undefined : json['extraction_error'],
        'extraction_job_id': json['extraction_job_id'] == null ? undefined : json['extraction_job_id'],
        'extraction_status': json['extraction_status'] == null ? undefined : json['extraction_status'],
        'ingestion_spec_id': json['ingestion_spec_id'] == null ? undefined : json['ingestion_spec_id'],
        'last_modified_at': json['last_modified_at'],
        'last_modified_by': json['last_modified_by'],
        'latest_version': json['latest_version'] == null ? undefined : json['latest_version'],
        'locked': json['locked'],
        'rejection_reason': json['rejection_reason'] == null ? undefined : json['rejection_reason'],
        'source_document': json['source_document'] == null ? undefined : DTADetailsSourceDocumentFromJSON(json['source_document']),
        'source_type': json['source_type'] == null ? undefined : SourceTypeFromJSON(json['source_type']),
        'spec_id': json['spec_id'] == null ? undefined : json['spec_id'],
        'status': DTAStatusFromJSON(json['status']),
        'status_history': json['status_history'] == null ? undefined : ((json['status_history'] as Array<any>).map(DTADetailsStatusHistoryInnerFromJSON)),
        'study_id': json['study_id'],
        'vendor_id': json['vendor_id'],
        'vendor_name': json['vendor_name'],
        'version': json['version'],
        'workflow_stage': WorkflowStageFromJSON(json['workflow_stage']),
    };
}

export function DTADetailsToJSON(json: any): DTADetails {
    return DTADetailsToJSONTyped(json, false);
}

export function DTADetailsToJSONTyped(value?: DTADetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approvals': value['approvals'] == null ? undefined : ((value['approvals'] as Array<any>).map(WorkflowApprovalToJSON)),
        'approved_at': value['approved_at'],
        'approved_by': value['approved_by'],
        'audit_trail': value['audit_trail'] == null ? undefined : ((value['audit_trail'] as Array<any>).map(DTADetailsAuditTrailInnerToJSON)),
        'created_at': value['created_at'],
        'created_by': value['created_by'],
        'data_stream_id': value['data_stream_id'],
        'document_content': DTADocumentContentToJSON(value['document_content']),
        'domains': value['domains'],
        'dta_id': value['dta_id'],
        'extraction_error': value['extraction_error'],
        'extraction_job_id': value['extraction_job_id'],
        'extraction_status': value['extraction_status'],
        'ingestion_spec_id': value['ingestion_spec_id'],
        'last_modified_at': value['last_modified_at'],
        'last_modified_by': value['last_modified_by'],
        'latest_version': value['latest_version'],
        'locked': value['locked'],
        'rejection_reason': value['rejection_reason'],
        'source_document': DTADetailsSourceDocumentToJSON(value['source_document']),
        'source_type': SourceTypeToJSON(value['source_type']),
        'spec_id': value['spec_id'],
        'status': DTAStatusToJSON(value['status']),
        'status_history': value['status_history'] == null ? undefined : ((value['status_history'] as Array<any>).map(DTADetailsStatusHistoryInnerToJSON)),
        'study_id': value['study_id'],
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
        'version': value['version'],
        'workflow_stage': WorkflowStageToJSON(value['workflow_stage']),
    };
}
